import React, { FC } from 'react';
import styled from 'styled-components';
import Button from '@minecraft.button';
import { DrawerProps } from '../shared/types';
import { useDrawerButtons, useDrawerToggle } from '../shared/hooks';

const DrawerFooterContainer = styled.div`
  border-top: 0.0625rem solid ${(props): string => props.theme.colors.primary.ltGrey1};
  display: flex;
  flex: 0 0 auto;
  padding: 1rem 1.5rem;
`;

const StyledButton = styled(Button)`
  min-width: auto;
  flex: 50%;
  padding-left: 1.375rem;
  padding-right: 1.375rem;

  &:not(:last-child) {
    margin-right: 1rem;
  }
`;

interface Props {
  cancelLabel: DrawerProps['cancelLabel'];
  submitLabel: DrawerProps['submitLabel'];
  cancelClick: DrawerProps['cancelClick'];
  submitClick: DrawerProps['submitClick'];
}

const DrawerFooter: FC<Props> = ({ cancelLabel = 'Cancel', submitLabel = 'Submit', cancelClick, submitClick }) => {
  const { toggleCancelButtonClicked } = useDrawerButtons();
  const { toggleDrawer } = useDrawerToggle();

  const handleCancel = async (): Promise<void> => {
    toggleCancelButtonClicked();

    if (cancelClick) {
      await Promise.all([cancelClick()]);
    }

    toggleCancelButtonClicked();
  };

  const handleSubmit = (): void => {
    submitClick();
    toggleDrawer();
  };

  return (
    <DrawerFooterContainer data-testid="drawer-footer-wrapper">
      <StyledButton data-testid="drawer-cancel-button" outlined type="button" onClick={handleCancel}>
        {cancelLabel}
      </StyledButton>
      <StyledButton data-testid="drawer-submit-button" type="button" onClick={handleSubmit}>
        {submitLabel}
      </StyledButton>
    </DrawerFooterContainer>
  );
};

export default DrawerFooter;
